import { render, staticRenderFns } from "./FigureBlock.vue?vue&type=template&id=66ec6706&scoped=true"
import script from "./FigureBlock.vue?vue&type=script&lang=js"
export * from "./FigureBlock.vue?vue&type=script&lang=js"
import style0 from "./FigureBlock.vue?vue&type=style&index=0&id=66ec6706&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec6706",
  null
  
)

export default component.exports